import React, { useState, useEffect, useRef } from 'react';
import { Modal, Col } from 'react-bootstrap';
import { connect, useStore } from 'react-redux';
import { bindActionCreators } from 'redux';
import fetchDux from '../../../state/fetch-dux';
import { actionCreators } from '../../../state/modals-dux';
import {
  actionCreators as cartHeaderActions
} from '../../../state/cart-header-dux';
import EditPaymentForm from './EditProfile/EditPaymentForm';
import ReactSelect from 'react-select';
import { submit } from 'redux-form';
import Icon from '../../ui/Icon';
import Loading from '../../ui/Loading';

const getCardType = cardTypeId => {
  switch (cardTypeId) {
    case 1:
      return 'Master';
    case 2:
      return 'Visa';
    case 3:
      return 'Amex';
    case 4:
      return 'Discover';
    default:
      return 'N/A';
  }
};

const ClubPaymentModal = (
  {
    openModal,
    user,
    closeModal,
    lookups,
    submitEditPaymentForm,
    acceptInvitation,
    waitListId,
    clubTypeId,
    acceptInvitationInProgress,
    getCart,
    getCartInProgress,
    setCartAdd,
    acceptInvitationError
  }
) => {
  const [selected, setSelected] = useState(null);
  const [agreedToTerms, toggleAgreedToTerms] = useState(false);
  const [showErrors, toggleShowErrors] = useState({});
  const didInitiateValidation = useRef(false);

  useEffect(
    () => {
      if (!didInitiateValidation.current) {
        return;
      }
      toggleShowErrors({ terms: !agreedToTerms, payment: selected === null });
    },
    [selected, agreedToTerms]
  );

  const validateAndSumbit = ({ submit, values }) => {
    didInitiateValidation.current = true;
    if (!agreedToTerms || (!selected && (CreditCards || []).length > 0)) {
      toggleShowErrors({ terms: !agreedToTerms, payment: selected === null });
      return;
    }
    if (submit) {
      const { value } = selected || { value: 'add' };
      const card = (CreditCards || [])
        .find(({ CardId }) => CardId === value) || {};
      const payload = {
        paymentMethod: value,
        waitListId,
        clubTypeId,
        ...card,
        ...values
      };
      acceptInvitation(payload, null, null, result => {
        const { success, kitId, qty } = result;
        if (success) {
          getCart(null, null, null, () => {
            setCartAdd({ kitId, qty });
            onHideHandler();
          });
        }
      });
    }
  };

  const onSubmitHandler = values => {
    validateAndSumbit({ values, submit: true });
  };

  const onHideHandler = () => {
    if (acceptInvitationInProgress || getCartInProgress) return;
    toggleShowErrors({ terms: false, payment: false });
    setSelected(null);
    didInitiateValidation.current = false;
    closeModal('ClubPaymentModal');
  };

  const { value: selectedAddressValue = '' } = selected || {};
  const { CreditCards = [], AddressBook = [] } = user || {};
  const defaultPaymentMethod = CreditCards.find(paymentMethod => {
    const { IsDefault } = paymentMethod;
    if (IsDefault) return paymentMethod;
  });
  const paymentOptions = CreditCards.map(({
    CardTypeId,
    CardId,
    LastFour,
    IsDefault
  }) => {
    const cardType = getCardType(CardTypeId);
    return {
      label: `${cardType.toUpperCase()} - **** **** **** ${LastFour}`,
      value: CardId,
      IsDefault
    };
  });
  useEffect(
    () => {
      if (!selected && defaultPaymentMethod) {
        setSelected(
          paymentOptions.find(
            ({ value }) => value === defaultPaymentMethod.CardId
          )
        );
      }
    },
    [defaultPaymentMethod]
  );

  if (paymentOptions.length > 0)
    paymentOptions.splice(0, 0, { label: 'Add Payment', value: 'add' });

  return (
    <Modal
      show={openModal === 'ClubPaymentModal'}
      onHide={onHideHandler}
      size="xl"
    >
      <Modal.Body>
        <h3 style={{ fontSize: '28pt' }}>Club Payment</h3>
        {CreditCards.length > 0 &&
          <div>
            {defaultPaymentMethod
              ? <h3 style={{ textTransform: 'none' }}>
                  We found the following default payment information for this account.
                  Please review and accept the terms and conditions. If you would like
                  to change your default payment method you can select another payment
                  or select to add a new one.
                </h3>
              : <h3 style={{ textTransform: 'none' }}>
                  We found the following payment options for this account but could not find a default
                  payment. Please select a payment that you would like to make your default payment method or
                  select to add a new one.
                </h3>}

            <h3 style={{ textTransform: 'none' }}>Payment</h3>
            <div
              className={
                `form-group-select form-group ${showErrors.payment ? 'has-error' : ''}`
              }
            >
              <div className="form-container">
                <ReactSelect
                  options={paymentOptions}
                  classNamePrefix="react-select"
                  placeholder="Select or add payment..."
                  onChange={value => setSelected(value)}
                  value={selected}
                />
                {showErrors.payment &&
                  <div className="form-error">
                    <Icon name="warning" /> Required
                  </div>}
              </div>
            </div>
          </div>}
        {CreditCards.length === 0 &&
          <h3 style={{ textTransform: 'none' }}>
            It appears we dont have any payments on record for this account. To complete the invitation
            process please use the form below to add a default payment.
          </h3>}
        {(CreditCards.length === 0 || selectedAddressValue === 'add') &&
          <EditPaymentForm
            onSubmit={onSubmitHandler}
            initialValues={{ IsDefault: true }}
            editType="Add"
            lookups={lookups}
            AddressBook={AddressBook}
            fromClubPaymentModal={true}
            style={{ maxWidth: '100%', padding: 0 }}
            toggle={onHideHandler}
          />}

        <div className="form-row">
          <div className="col-md-12">
            <div
              className={`form-group ${showErrors.terms ? 'has-error' : ''}`}
            >
              <div className="form-container inline-checkbox">
                <label className="checkbox">
                  <input
                    type="checkbox"
                    className="form-control"
                    onChange={event =>
                      toggleAgreedToTerms(event.target.checked)}
                  />
                  <strong
                    style={{
                      marginLeft: '0.5rem',
                      color: '#979797',
                      fontFamily: 'trade-gothic-next-condensed, sans-serif',
                      fontSize: '0.8rem'
                    }}
                  >
                    I accept the terms and conditions
                  </strong>
                </label>
                {showErrors.terms &&
                  <div
                    className="form-error"
                    style={{ right: '76.5%', bottom: '70%' }}
                  >
                    <Icon name="warning" /> Required
                  </div>}
              </div>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="col-md-3 form-group">
            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={acceptInvitationInProgress || getCartInProgress}
              onClick={() => {
                if (
                  selectedAddressValue === 'add' || CreditCards.length === 0
                ) {
                  submitEditPaymentForm('edit-payment-form');
                  validateAndSumbit({ submit: false });
                  return;
                }
                validateAndSumbit({ submit: true });
              }}
            >
              Confirm payment
            </button>
          </div>
          <div className="col-md-3">
            <button
              type="button"
              className="btn btn-inverse btn-block"
              onClick={onHideHandler}
              disabled={acceptInvitationInProgress || getCartInProgress}
            >
              Cancel
            </button>
          </div>
          {(acceptInvitationInProgress || getCartInProgress) && <Loading />}
        </div>

        {acceptInvitationError &&
          <div className="form-row">
            <span style={{ color: 'red', marginLeft: '10px' }}>
              {acceptInvitationError.message || ''}
            </span>
          </div>}
      </Modal.Body>
    </Modal>
  );
};

const mapState = state => {
  const {
    inProgress: acceptInvitationInProgress,
    error: acceptInvitationError
  } = state.acceptInvitation.toJS();

  const {
    inProgress: getCartInProgress
  } = state.getCart.toJS();
  return {
    openModal: state.modals,
    acceptInvitationInProgress,
    getCartInProgress,
    acceptInvitationError
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postCard: fetchDux.postCard.createAction,
      submitEditPaymentForm: submit,
      acceptInvitation: fetchDux.acceptInvitation.createAction,
      getCart: fetchDux.getCart.createAction,
      ...cartHeaderActions,
      ...actionCreators
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(ClubPaymentModal);
